import { useState, useEffect } from "react";
import "../challenge-joining-frames.css";
import Logo from "../../../../../ui/atoms/logo/Logo";
import BackgroundPaths from "../../../../../ui/molecules/background-paths/BackgroundPaths";
import { TbLoader } from "react-icons/tb";
import Loading from "../../../../../ui/atoms/loading/Loading";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import { socketIo } from "../../../../../core/socket/socket-client";
import { onWaitingRoom } from "../../../services/challenge";
import { capitalizeAll } from "../../../../../core/utils/helpers";
import useAxiosPrivate from "../../../../../app/providers/context-provider/useAxiosPrivate";

const JoiningWaitingRoomFrame = () => {
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();

  const [challengeData, setChallengeData] = useState({});

  const initConnectedUser = useSelector(
    (state) => state.setInitConf.initConnectedUser,
  );
  const _sys_role = initConnectedUser?.sys_role;

  const currentConnectedStream = useSelector(
    (state) => state.setInitConf.currentConnectedStream,
  );
  const _inscription_id = currentConnectedStream?.inscription_id;

  const currentAssessment = useSelector(
    (state) => state?.challengeState?.currentAssessment,
  );
  const _request_id = currentAssessment?.request_id

  useEffect(() => {
    onHandleWaitingRoom();
  }, []);

  useEffect(() => {
    socketIo.emit("authenticate", { inscription_id: _inscription_id });

    const onHandleChallengeState = (data) => {
      if (data?.status) onHandleWaitingRoom();
    };

    socketIo.on("on_challenge_current_status", onHandleChallengeState);

    return () => {
      socketIo.off("on_challenge_current_status", onHandleChallengeState);
    };
  }, [challengeData]);

  const onHandleWaitingRoom = async () => {
    let isMounted = true;
    const controller = new AbortController();
    const signal = controller.signal;

    const local_data = {
      request_id: _request_id,
    };

    onWaitingRoom(axiosPrivate, local_data, signal)
      .then((response) => {
        const _data = response?.data;
        const _status = _data?.status;
        // const _challenge_id = _data?.challenge_id;
        const _challenge_status = _data?.challenge_current_status;
        setChallengeData(_data);

        if (_status) {
          if (_challenge_status === "hosting") {
            navigate(
              `/${_sys_role}/challenge/play`,
              { replace: true },
            );
          }
        }
      })
      .catch((error) => {
        if (!error?.response) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "No server response",
          });
        } else {
          Swal.fire({
            icon: "warning",
            title: "Warning",
            text: error.response.data?.message || "An error occurred",
          });
        }
      });

    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  };

  return (
    <div className="joining-frame">
      <div className="j-f-inner">
        <BackgroundPaths />
      </div>
      <div className="j-f-outer">
        <div className="j-f-outer-head">
          <Logo to={null} width={"200px"} />
          <h1>Pamoja 4 Machine Intelligence University</h1>
          <div className="w-fit-content d-flex justify-center align-center p-xs">
            <TbLoader className="icon" />
            <span>Waiting Room</span>
          </div>
          <p>Waiting for Host to start challenge...!</p>
        </div>
        <div className="j-f-outer-wrapper waiting-room-wrapper">
          {challengeData?.teams?.map((team, idx) => {
            return (
              team?.members?.length > 0 && (
                <div className="team-item" key={idx}>
                  {challengeData?.challenge_type === "team" && (
                    <div className="t-i-head">
                      <h3>{capitalizeAll(team?.team_name)}</h3>
                    </div>
                  )}
                  <div className="t-i-members">
                    {team?.members?.map((member, j) => (
                      <span key={j}>
                        {capitalizeAll(member?.member_name)}{" "}
                        {member?.is_me && "(Me)"}
                      </span>
                    ))}
                  </div>
                </div>
              )
            );
          })}
        </div>
        <div className="p-lg">
          <Loading type={"type-1"} />
        </div>
      </div>
    </div>
  );
};

export default JoiningWaitingRoomFrame;
